export function addQueryParamsToExistingUrl({
    url,
    queryParams,
}: {
    url: string;
    queryParams: Record<string, string>;
}): string {
    const urlObject = new URL(url);
    const queryParamsInUrl = new URLSearchParams(urlObject.search);
    Object.keys(queryParams).forEach((key) => {
        queryParamsInUrl.set(key, queryParams[key]);
    });
    urlObject.search = queryParamsInUrl.toString();
    return urlObject.toString();
}
